import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
// import { SpriteSvg, SpriteSvgType } from '../../../components/sprite-svg';
import { ISystemMenuItem } from '../../../model/system/menu';
import { IMyFavoriteItem } from '../../../model/api-modules';
import MenuCollect from '../../../assets/svg/menu-collect.svg';
import MenuCollectHover from '../../../assets/svg/menu-collect-hover.svg';
import MenuCollectActive from '../../../assets/svg/menu-collect-active.svg';
import { SvgIcon } from '../../component/svg-icon';
import { SvgIconName } from '../../component/svg-icon/model';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store/reducers';
import { IApiGameEnvCollectionRes } from '../../../model/api-modules/env';
import { isVersionGreaterThan } from '../lib';

interface IProps {
  readonly menu: ISystemMenuItem;
  readonly myFavoriteList: ReadonlyArray<IMyFavoriteItem>;
  readonly selectedMenuID: string;
  readonly isSubMenu?: boolean;
  readonly isFavoriteMenu?: boolean;
  readonly onClickItem: (key: number) => void;
  readonly addFavorites: (id: number, status: number) => void;
}

export const MenuItem = (props: IProps) => {
  const [gameID, setGameID] = useState<string>('');
  const [envItem, setEnvItem] = useState<IApiGameEnvCollectionRes | null>(null);
  const isFavorite = props.myFavoriteList.find(
    (item) => item.ServiceID === Number(props.menu.id)
  );
  const pathName = location.pathname;
  const allEnvList = useSelector((state: IRootState) => state.games.allEnvList);

  useEffect(() => {
    const pathNameArr = pathName.split('/');
    const consoleIndex = pathNameArr.indexOf('console');
    if (consoleIndex !== -1) {
      const gameId = pathNameArr[consoleIndex + 2];
      const envId = pathNameArr[consoleIndex + 3];
      const currentEnv = allEnvList.find(
        (item) => item.envIncrementID.toString() === envId
      );
      if (gameId) {
        setGameID(gameId);
      }
      if (currentEnv) {
        setEnvItem(currentEnv);
        return;
      }
    }
    setEnvItem(null);
  }, [pathName]);

  const addFavorites = async (
    event: React.MouseEvent<HTMLDivElement>,
    id: number,
    status: number
  ) => {
    event.stopPropagation();
    props.addFavorites(id, status);
  };

  const renderMenuItem = () => {
    let canSelect = false;
    if (isFavorite && props.isFavoriteMenu) {
      canSelect = true;
    } else if (!isFavorite) {
      canSelect = true;
    }
    const className = classNames(
      'nav-item',
      props.menu.id === props.selectedMenuID && canSelect ? 'active' : ''
    );

    const pathNameArr = pathName.split('/');
    const consoleIndex = pathNameArr.indexOf('console');
    const envId = pathNameArr[consoleIndex + 3];
    const currentEnv = allEnvList.find(
      (item) => item.envIncrementID.toString() === envId
    );
    const itemGos = JSON.parse(currentEnv?.envGosParams || '{}');
    // 低于1.12.0版本没有一级Matchmaking服务
    if (
      props.menu.name === 'Matchmaking' &&
      !isVersionGreaterThan(itemGos?.GameServiceVersion)
    ) {
      return null;
    }

    return (
      <li
        onClick={() => {
          props.onClickItem(Number(props.menu.id));
          if (gameID && envItem?.envIncrementID) {
            /* auditServiceReadLog(
              `View${props.menu.name.replace(/[\W_]/g, '')}`,
              {
                gameID,
                envID: envItem.envIncrementID,
                envType:
                  envItem.envType === GameEnvType.Live
                    ? IAuditEnvType.Prod
                    : IAuditEnvType.Dev,
              }
            );*/
          }
        }}
        className="nav-position-box"
      >
        <div className={className}>
          <div className="nav-icon">
            {props.menu.icon ? (
              <SvgIcon
                icon={props.menu.icon as SvgIconName}
                className={
                  props.menu.id === props.selectedMenuID && canSelect
                    ? 'active'
                    : ''
                }
              />
            ) : null}
          </div>
          <span className="nav-text">{props.menu.name}</span>
        </div>
        {!props.isFavoriteMenu &&
          (isFavorite ? (
            <div
              className="item-collect-box"
              onClick={(e) => addFavorites(e, Number(props.menu.id), 0)}
            >
              <img className="nav-item-collect" src={MenuCollectActive} />
            </div>
          ) : (
            <div
              className="item-collect-box"
              onClick={(e) => addFavorites(e, Number(props.menu.id), 1)}
            >
              <img
                className="nav-item-collect collect-default"
                src={MenuCollect}
              />
              <img
                className="nav-item-collect collect-hover"
                src={MenuCollectHover}
              />
            </div>
          ))}
      </li>
    );
  };

  return <ul className="sidebar-nav">{renderMenuItem()}</ul>;
};
